import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBraveComponent } from './simple-icons-brave.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBraveComponent ],
    exports:      [ SimpleIconsBraveComponent ],
    bootstrap:    []
})
export class SimpleIconsBraveModule {}
